module.exports = "../images/expect-hunting.jpg?v=347d9b0";